import { render, staticRenderFns } from "./CustomBill.vue?vue&type=template&id=33807e6d"
import script from "./CustomBill.vue?vue&type=script&lang=js"
export * from "./CustomBill.vue?vue&type=script&lang=js"
import style0 from "./CustomBill.vue?vue&type=style&index=0&id=33807e6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports